<template>
  <button-common :disabled='true'>
    {{ $l.eventEntried }}
  </button-common>
</template>

<script>
import ButtonCommon from '@/components/Button'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonCommon
  }
}
</script>

